import { render } from "./enrolmentStep2.vue?vue&type=template&id=3707dddc&scoped=true"
import script from "./enrolmentStep2.vue?vue&type=script&lang=js"
export * from "./enrolmentStep2.vue?vue&type=script&lang=js"

import "./enrolmentStep2.vue?vue&type=style&index=0&id=3707dddc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3707dddc"]])

export default __exports__